export default __webpack_public_path__ + "static/media/DSC_0565.e64c2315.webp";